import { DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { DeliverableStatus, StatusCode } from '../../shared-controls/status/statusCodesMap';
import { StatusBasedValuePipe } from './status-based-value.pipe';

@Pipe({
  name: 'statusNumber',
})
export class NumberStatusPipe implements PipeTransform {
  constructor(
    private decimalPipe: DecimalPipe,
    private statusBasedPipe: StatusBasedValuePipe,
  ) {}
  transform(value: any, status: StatusCode | DeliverableStatus, format?: string, locale?: string): any {
    value = this.statusBasedPipe.transform(value, status);

    if (isNaN(value)) {
      return value;
    }

    return this.decimalPipe.transform(value, format, locale);
  }
}
